
export default {
  name: "PageHeader",
  props: {
    title: String,
    description: String,
    bannerUrl: { type: String, default: "/images/home/startup-header.png" },
    breadcrumbItems: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    style() {
      return {
        background: `url(${this.bannerUrl})`,
        "background-size": "cover",
        "background-repeat": "no-repeat",
        "background-position": "center",
      };
    },
  },
};
